import {createSlice} from "@reduxjs/toolkit";

const initialGiveawayState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  giveawayForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const giveawaySlice = createSlice({
  name: "giveaway",
  initialState: initialGiveawayState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findGiveaway
    giveawayFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.data = data;
    },
    // createGiveaway
    giveawayCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // updateGiveaway
    giveawayUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    
  }
});
